<template>
  <div>
    <div class="content-box">
      <div class="support-index">
        <div class="support-tickets">
          <div class="support-tickets-header">
            <div class="tickets-control">
              <h5>
                Buzon RRHH
              </h5>
            </div>
            <div class="tickets-filter">
              <div class="form-group mr-3">
                <label class="d-none d-md-inline-block mr-2">Estatus</label>
                <select
                  class="form-control-sm"
                  v-model="filtros.estado"
                  @change="refreshListado"
                >
                  <option value="">
                    Todos
                  </option>
                  <option value="A">
                    Abierto
                  </option>
                  <option value="R">
                    Resuelto
                  </option>
                  <option value="9">
                    Anulado
                  </option>
                </select>
              </div>
              <div class="form-group mr-1">
                <label class="d-none d-md-inline-block mr-2">Tipo</label>
                <select
                  class="form-control-sm"
                  v-model="filtros.tipo"
                  @change="refreshListado"
                >
                  <option value="">
                    Todos
                  </option>
                  <option value="C">
                    Comentario
                  </option>
                  <option value="S">
                    Sugerencia
                  </option>
                  <option value="Q">
                    Queja
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div
            class="support-ticket "
            v-for="ticket in buzon_list"
            :key="ticket.id"
            @click="seleccionarTicket(ticket.id)"
          >
            <div class="st-meta">
              <div
                class="badge badge-success-inverted"
                v-if="ticket.tipo == 'C'"
              >
                Comentario
              </div>
              <div
                class="badge badge-warning-inverted"
                v-if="ticket.tipo == 'S'"
              >
                Sugerencia
              </div>
              <div
                class="badge badge-danger-inverted"
                v-if="ticket.tipo == 'Q'"
              >
                Sugerencia
              </div>
              <div class="status-pill green" v-if="ticket.estado == 'A'"></div>
              <div class="status-pill blue" v-if="ticket.estado == 'B'"></div>
              <div class="status-pill red" v-if="ticket.estado == '9'"></div>
            </div>
            <div class="st-body">
              <div class="ticket-content">
                <h6 class="ticket-title">
                  <span v-if="ticket.nombre != '' && ticket.nombre != null">
                    {{ ticket.nombre }}
                  </span>
                  <span v-if="!(ticket.nombre != '' && ticket.nombre != null)">
                    Anónimo
                  </span>
                </h6>
                <div class="ticket-description ">
                  {{ ticket.comentario | truncate(200, "...") }}
                </div>
              </div>
            </div>
            <div class="st-foot">
              <span class="label">Colaborador:</span>
              <a class="value with-avatar" href="#">
                <span v-if="ticket.nombre != '' && ticket.nombre != null">
                  {{ ticket.nombre }}
                </span>
                <span v-if="!(ticket.nombre != '' && ticket.nombre != null)">
                  Anónimo
                </span>
              </a>
              <span class="label">Fecha:</span>
              <span class="value">
                <timeago
                  :title="ticket.fecha_creacion"
                  :datetime="ticket.fecha_creacion"
                >
                </timeago>
              </span>
            </div>
          </div>
        </div>
        <div class="support-ticket-content-w">
          <div class="support-ticket-content">
            <h3 class="ticket-header">
              <span v-if="current.nombre != '' && current.nombre != null">
                {{ current.nombre }}
              </span>
              <span v-if="!(current.nombre != '' && current.nombre != null)">
                Anónimo
              </span>
            </h3>
            <div class="support-ticket-content-header">
              {{ current.comentario }}
              <a class="back-to-index" href="#">
                <i class="os-icon os-icon-arrow-left5"> </i>
                <span>Back</span>
              </a>
              <a class="show-ticket-info" href="#">
                <span>Show Details</span>
                <i class="os-icon os-icon-documents-03"> </i>
              </a>
            </div>
            <div class="ticket-thread">
              <div
                class="ticket-reply highlight"
                v-for="comentario in current.comentarios"
                :key="comentario.id"
              >
                <div class="ticket-reply-info">
                  <UsuarioCuadradoComponent :current="comentario.usuario" />
                  <span class="info-data">
                    <span class="label">Fecha:</span>
                    <span class="value">
                      <timeago
                        v-if="comentario.fecha_creacion"
                        :title="comentario.fecha_creacion"
                        :datetime="comentario.fecha_creacion"
                      >
                      </timeago>
                    </span>
                  </span>
                </div>
                <div class="ticket-reply-content">
                  <div v-html="comentario.comentario"></div>
                </div>
              </div>

              <div class="aec-reply" v-if="current.id">
                <div class="reply-header">
                  <h5>
                    Comentar como <span>{{ current_user }}</span>
                  </h5>
                </div>

                <ckeditor
                  v-model="nuevo_comentario.comentario"
                  :config="editorConfig"
                ></ckeditor>
                <div class="buttons-w">
                  <div class="actions-right">
                    <button class="btn btn-success" @click="agregarComentario">
                      <i class="os-icon os-icon-mail-18"> </i>
                      <span>Comentar</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="support-ticket-info">
            <div class="customer">
              <h4 class="customer-name">
                <span v-if="current.nombre != '' && current.nombre != null">
                  {{ current.nombre }}
                </span>
                <span v-if="!(current.nombre != '' && current.nombre != null)">
                  Anónimo
                </span>
              </h4>
              <div class="customer-tickets">
                <span v-if="current.telefono != '' && current.telefono != null">
                  Teléfono: {{ current.telefono }}
                </span>
                <br />
                <span v-if="current.email != '' && current.email != null">
                  Email: {{ current.email }}
                </span>
                <br />
                <span v-if="current.puesto != '' && current.puesto != null">
                  Puesto: {{ current.puesto }}
                </span>
              </div>
            </div>
            <h5 class="info-header">
              Detalle Buzón
            </h5>
            <div class="info-section text-center">
              <div class="label">
                Fecha:
              </div>
              <div class="value">
                {{ current.fecha_creacion }}
                <br />
                <br />
                <timeago
                  v-if="current.fecha_creacion"
                  :title="current.fecha_creacion"
                  :datetime="current.fecha_creacion"
                >
                </timeago>
              </div>
              <div class="value">
                <div class="badge badge-success" v-if="current.tipo == 'C'">
                  Comentario
                </div>
                <div class="badge badge-warning" v-if="current.tipo == 'S'">
                  Sugerencia
                </div>
                <div class="badge badge-danger" v-if="current.tipo == 'Q'">
                  Sugerencia
                </div>
                <br />
                <div
                  class="status-pill green"
                  v-if="current.estado == 'A'"
                ></div>
                <div
                  class="status-pill blue"
                  v-if="current.estado == 'B'"
                ></div>
                <div class="status-pill red" v-if="current.estado == '9'"></div>
              </div>
            </div>
            <h5 class="info-header">
              Participantes
            </h5>
            <div class="info-section">
              <ul class="users-list as-tiles">
                <li
                  v-for="participante in current.participantes"
                  :key="participante.id"
                >
                  <UsuarioCuadradoComponent :current="participante" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import UsuarioCuadradoComponent from "@/components/commons/UsuarioCuadradoComponent";

export default {
  components: {
    UsuarioCuadradoComponent,
  },
  data() {
    return {
      current_user: null,
      editorConfig: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "-",
            "NumberedList",
            "BulletedList",
            "-",
            "Link",
            "Unlink",
            "-",
            "About",
          ],
        ],
        uiColor: "#ffffff",
        height: 110,
      },
      filtros: {
        estado: "A",
        tipo: "C",
      },
      buzon_list: [],
      current: {
        fecha_creacion: null,
      },
      nuevo_comentario: {
        comentario: "",
      },
    };
  },
  computed: {},
  mounted() {
    let self = this;
    self.current_user = localStorage.getItem("name");
    self.refreshListado();
  },
  methods: {
    refreshListado() {
      let self = this;
      let params = Object.assign({ quitar_paginacion: true }, self.filtros);
      DynamicService.fetch("rrhh", "buzon-sugerencias", params).then(
        (response) => {
          self.buzon_list = response.data;
          if (self.buzon_list.length != 0) {
            self.seleccionarTicket(self.buzon_list[0].id);
          }
        }
      );
    },
    seleccionarTicket(id) {
      let self = this;
      DynamicService.getById("rrhh", "buzon-sugerencias", id).then(
        (response) => {
          self.current = response.data;
          self.nuevo_comentario.comentario = "";
        }
      );
    },
    agregarComentario() {
      let self = this;
      DynamicService.postAction(
        "rrhh",
        "buzon-sugerencias",
        self.current.id,
        "agregar_comentario",
        self.nuevo_comentario
      )
        .then((response) => {
          self.seleccionarTicket(self.current.id);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    },
  },
};
</script>
